export const OWLS_LOCALIZED_AUTOCOMPLETE = 3320;
export const MIRA_ENTRY_POINTS_V1 = 5263;
